var paragraph_default = {
  "fontElementMap": "m8oTq",
  "elementSpacing": "naMKD",
  "text": "M2g-j naMKD",
  "child": "iBZzo"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
